export class FacilityBase {
    protected isAttendeeCountRequired = false;
    protected isWaitlistEnabled = false;
    protected isChargable = false;
    protected isHoldBooking = false;
    protected isMaxBookingPerMembership = false;
    protected isMaxBookingPerPerson = false;
    protected isPeakTimeEnabled = true;
    protected isBreakTimeEnabled = true;
    protected isReadOnly = false;
    protected editStatus = false;
    protected viewStatus = false;
    protected addFacilityStatus = false;
    protected closeTime;
    protected closeTimeArray;
    protected openTime;
    protected peekTimingsArray = [];
    protected closedTime = {};
    protected closedStartTime;
    protected closedEndTime;
    protected peekStartTime;
    protected peekEndTime;
    protected peakTime = {};
    protected clubName = '';
    protected pageName;
    protected unitNames;
    constructor() {
    }

    /**
         * Toggle buttons for active or not
         * 
         * @param  flag as true or false
         * 
         * @Toggle button
         */
    toggle(that, Case, flag) {
        switch (Case) {
            case 1:
                that.isAttendeeCountRequired = flag;
                break;
            case 2:
                that.isWaitlistEnabled = flag;
                break;
            case 3:
                that.isChargable = flag;
                break;
            case 4:
                that.isHoldBooking = flag;
                break;
            case 5:
                that.isMaxBookingPerMembership = flag;
                break;
            case 6:
                that.isMaxBookingPerPerson = flag;
                break;
            case 7:
                that.isPeakTimeEnabled = flag;
                break;
            case 8:
                that.isBreakTimeEnabled = flag;
                break;
        }
    }

    /**
 * Change status for view facility mode
*/

    changeStatus(that) {
        try {
            that.isReadOnly = !that.isReadOnly;
            that.editStatus = !that.editStatus;
            this.setLocalFlagWithFacilityRules(that);
            this.setDefaultValues(that);
        } catch (err) {
            console.log(err);
        }
    }

    setLocalFlagWithFacilityRules(that) {
        that.isAttendeeCountRequired = that.facility.isAttendeeCountRequired;
        that.isWaitlistEnabled = that.facility.isWaitlistEnabled;
        that.isChargable = that.facility.isChargable;
        that.isHoldBooking = that.facility.isHoldBooking;
        that.isMaxBookingPerMembership = that.facility.isMaxBookingPerMembership;
        that.isMaxBookingPerPerson = that.facility.isMaxBookingPerPerson;
        that.isPeakTimeEnabled = that.facility.isPeakTimeEnabled;
        that.isBreakTimeEnabled = that.facility.isBreakTimeEnabled;
    }
    /**
         * 
         * 
         * Set Default Values if values are undefined or null
         */

    setDefaultValues(that) {
        try {
            if (that.facility.maxNumberOfPeopleWeekend == null || that.facility.maxNumberOfPeopleWeekend === undefined) {
                that.facility.maxNumberOfPeopleWeekend = '';
            }
            if (that.facility.maxNumberOfPeopleWeekday == null || that.facility.maxNumberOfPeopleWeekday === undefined) {
                that.facility.maxNumberOfPeopleWeekday = '';
            }
            if (that.facility.maxNumberOfPeopleWeekday == null || that.facility.maxNumberOfPeopleWeekday === undefined) {
                that.facility.maxNumberOfPeopleWeekday = '';
            }
            if (that.facility.waitlistCount == null || that.facility.waitlistCount === undefined) {
                that.facility.waitlistCount = '';
            }
            if (that.facility.waitlistCount == null || that.facility.waitlistCount === undefined) {
                that.facility.waitlistCount = '';
            }
            if (that.facility.amount.value == null || that.facility.amount.value === undefined) {
                that.facility.amount.value = '';
            }
            if (that.facility.holdBookingDays == null || that.facility.holdBookingDays === undefined) {
                that.facility.holdBookingDays = '';
            }
            if (that.facility.maxWeekdayBooking == null || that.facility.maxWeekdayBooking === undefined) {
                that.facility.maxWeekdayBooking = '';
            }
            if (that.facility.maxWeekendBooking == null || that.facility.maxWeekendBooking === undefined) {
                that.facility.maxWeekendBooking = '';
            }
            if (that.facility.maxBookingHoursWeekday == null || that.facility.maxBookingHoursWeekday === undefined) {
                that.facility.maxBookingHoursWeekday = '';
            }
            if (that.facility.maxBookingHoursWeekend == null || that.facility.maxBookingHoursWeekend === undefined) {
                that.facility.maxBookingHoursWeekend = '';
            }
            if (that.facility.slotDuration == null || that.facility.slotDuration === undefined || that.facility.slotDuration + '' === '0') {
                that.facility.slotDuration = '';
            }
        } catch (err) {
            console.log(err);
        }
    }

    setFlagBeforeViewFacility(that) {
        that.iconSelect = '';
        that.viewIcon.name = '';
        that.viewIcon.iconClass = '';
        that.facility.peekTimings = [];
        that.peekTimingsArray = [];
        that.closeTimeArray = [];
        that.defaultValue = true;
        that.saveFlag = true;
        that.functionHallFlag = false;
        that.viewStatus = true;
        that.isReadOnly = true;
        that.editStatus = false;
    }

    setTimingsForFacility(that) {
        let timeObject = {};
        that.openTime = that.facility.timings.openTime.replace(/:00:00/g, '');
        that.closeTime = that.facility.timings.closeTime.replace(/:00:00/g, '');
        for (let i = 0; i < that.facility.breakTimings.length; i++) {
            timeObject['start'] = that.facility.breakTimings[i].start.replace(/:00:00/g, '');
            timeObject['end'] = that.facility.breakTimings[i].end.replace(/:00:00/g, '');
            that.closeTimeArray.push(timeObject);
            timeObject = {};
        }
        for (let item of that.facility.peekTimings) {
            timeObject['start'] = item.start.replace(/:00:00/g, '');
            timeObject['end'] = item.end.replace(/:00:00/g, '');
            that.peekTimingsArray.push(timeObject);
            timeObject = {};
        }
    }

    setFlagsForDisableBookings(that) {
        that.functionHallFlag = true;
        that.facility.slotDuration = '';
        that.facilityValidationObj.validate.validSlotDuration = '';
        that.facility.peakUnitsCount = '';
        that.facilityValidationObj.validate.validPeekSlotDuraion = '';
        that.peekTimingsArray = [];
        that.facilityValidationObj.validate.validPeekTime = '';
        that.isPeakTimeEnabled = false;
    }


    /**
    * Remove closed time from closedTime Array
    */

    removeCloseTime(that, time) {
        try {
            let index = that.closeTimeArray.indexOf(time);
            that.closeTimeArray.splice(index, 1);
        } catch (err) {
            console.log(err);
        }
    }

    /**
    * Add closed time in closedTime Array
    */

    addCloseTime(that) {
        try {
            if (that.closedStartTime && that.closedEndTime) {
                that.closedTime['start'] = that.closedStartTime;
                that.closedTime['end'] = that.closedEndTime;
                that.closeTimeArray.push(that.closedTime);
                that.closedTime = {};
                that.closedStartTime = '';
                that.closedEndTime = '';
            }
        } catch (err) {
            console.log(err);
        }
    }

    /**
     * Add peek time in peekTime Array
     */

    addPeekTimings(that) {
        try {
            if (that.peekStartTime && that.peekEndTime) {
                that.peakTime['start'] = that.peekStartTime;
                that.peakTime['end'] = that.peekEndTime;
                that.peekTimingsArray.push(that.peakTime);
                that.peakTime = {};
                that.peekStartTime = '';
                that.peekEndTime = '';
            }
        } catch (err) {
            console.log(err);
        }
    }

    /**
    * Remove peek time from peekTime Array
    */

    removePeakTime(that, time) {
        try {
            let index = that.peekTimingsArray.indexOf(time);
            that.peekTimingsArray.splice(index, 1);
        } catch (err) {
            console.log(err);
        }
    }

}   


// WEBPACK FOOTER //
// ./src/app/facility/facility-rule/facility-base.ts